import React, { useEffect, useState } from "react";
import PrimaryBtn from "src/Components/GlobalComponents/primaryBtn";
import SelectDropdown from "src/Components/GlobalComponents/SelectDropdown";
import SimpleInput from "src/Components/SimpleInput";
import { IPharmaInventoryCreate, ITagsItems } from "src/types/GlobalInterfaces";
import httpRequest from "src/helpers/httpRequest";
import { toast } from "react-toastify";
import { IPaginated } from "src/types/paginated";
import CustomWebsiteDropdown from "src/Components/GlobalComponents/Widget/CustomWebsiteDropdown";
import { Option } from "react-multi-select-component";

interface IProps {
  state: IPharmaInventoryCreate;
  setState: (key: keyof IPharmaInventoryCreate, val: any) => void;
  tabChange: () => void;
}

interface ICategoryResponse {
  documents: ITagsItems[];
  paginated: IPaginated;
}

const InventoryTagsTab: React.FC<IProps> = ({ state, setState, tabChange }) => {
  const [isLoader, setIsLoader] = useState(false);
  const [allProfessionalTags, setAllProfessionalTags] = useState<ITagsItems[]>(
    []
  );
  const [allProductTags, setAllProductTags] = useState<ITagsItems[]>([]);

  const getPropotionalTags = async () => {
    setIsLoader(true);
    let pth = "/tags/promotional/all";
    const { res, err } = await httpRequest<ICategoryResponse>({
      path: `${pth}`,
    });
    if (res) {
      setAllProfessionalTags(res?.documents);
    } else {
      toast(err, { type: "error" });
    }
    setIsLoader(false);
  };

  const getProductTags = async () => {
    setIsLoader(true);
    let pth = "/tags/product/all";
    const { res, err } = await httpRequest<ICategoryResponse>({
      path: `${pth}`,
    });
    if (res) {
      setAllProductTags(res?.documents);
    } else {
      toast(err, { type: "error" });
    }
    setIsLoader(false);
  };

  useEffect(() => {
    getPropotionalTags();
    getProductTags();
  }, []);

  return (
    <>
      <div className="products-tabs-content">
        {/* <SelectDropdown
          loader={isLoader}
          options={allProfessionalTags.map((v) => ({
            label: v?.name,
            value: v?._id,
            color: v?.color,
          }))}
          isMulti={false}
          data={allProfessionalTags
            .filter((v) => v?._id === state?.promotionalTag)
            .map((v) => ({ label: v?.name, value: v?._id , color : v?.color}))}
          setData={(e : any) => {
            setState("promotionalTag", e[0]?.value || "");
            setState("promotionalTagName", {
              name: e[0]?.label || "",
              color: e[0]?.color || "",
            });
          }}
          checkboxShow={false}
          isLabel={true}
          labelText="Professional Tag"
          placeholder={{ selectSomeItems: "Select Professional Tag" }}
        /> */}

        <CustomWebsiteDropdown
          options={allProfessionalTags.map((v) => ({
            label: v?.name,
            value: v?._id,
            color: v?.color,
          }))}
          data={allProfessionalTags
            .filter((v) => v?._id === state?.promotionalTag)
            .map((v) => ({ label: v?.name, value: v?._id, color: v?.color }))}
          setData={(e: any) => {
            setState("promotionalTag", e[0]?.value || "");
            setState("promotionalTagName", {
              name: e[0]?.label || "",
              color: e[0]?.color || "",
            });
          }}
          labelText="Professional Tag"
          isRequired={true}
          dropdownMainId="professional-tag-dropdown"
          clearId="professional-tag-clear"
          optionId={(v: Option, index) =>
            `professional-tag-option-${index + 1}`
          }
          loading={isLoader}
        />

        {/* <SelectDropdown
          loader={isLoader}
          options={allProductTags.map((v) => ({
            label: v?.name,
            value: v?._id,
            color: v?.color,
          }))}
          isMulti={true}
          data={allProductTags
            .filter((v) => state?.productTags?.includes(v?._id))
            .map((v) => ({ label: v?.name, value: v?._id , color : v?.color}))}
          setData={(e) => {
            setState("productTags", e.map((v) => v?.value) || []);
            setState("productTagsName", e.map((v : any) => v?.label) || []);
          }}
          checkboxShow={true}
          isLabel={true}
          labelText="Product Tag"
          placeholder={{ selectSomeItems: "Select Product Tag" }}
        /> */}

        <CustomWebsiteDropdown
          options={allProductTags.map((v) => ({
            label: v?.name,
            value: v?._id,
            color: v?.color,
          }))}
          data={allProductTags
            .filter((v) => state?.productTags?.includes(v?._id))
            .map((v) => ({ label: v?.name, value: v?._id, color: v?.color }))}
          setData={(e: any) => {
            setState("productTags", e.map((v: any) => v?.value) || []);
            setState("productTagsName", e.map((v: any) => v?.label) || []);
          }}
          labelText="Product Tag"
          isRequired={true}
          dropdownMainId="product-tag-dropdown"
          clearId="product-tag-clear"
          optionId={(v: Option, index) => `product-tag-option-${index + 1}`}
          loading={isLoader}
          isMulti={true}
        />
      </div>
      <div className="flex justify-end my-6">
        <PrimaryBtn
          ButtonText="Next"
          btnExtraStyle={{ backgroundColor: "#00443f", borderRadius: "1.5rem" }}
          onPress={tabChange}
          id="next-btn"
        />
      </div>
    </>
  );
};

export default InventoryTagsTab;
